/* eslint-disable import/prefer-default-export */
import { addLoading, removeLoading } from './loading';
import productFeedbackReasonRequests from '../../server/productFeedbackReason';


export const getListProductFeedbackReason = (limit, skip, search, orderBy, field) => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await productFeedbackReasonRequests.getListProductFeedbackReason(limit, skip, search, orderBy, field);
  } finally {
    dispatch(removeLoading());
  }
};

export const updateProductFeedbackReason = productFeedbackReasonParameter => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await productFeedbackReasonRequests.updateProductFeedbackReason(productFeedbackReasonParameter);
  } finally {
    dispatch(removeLoading());
  }
};

export const createProductFeedbackReason = newProductFeedbackReason => async (dispatch) => {
  dispatch(addLoading());
  try {
    await productFeedbackReasonRequests.createProductFeedbackReason(newProductFeedbackReason);
  } finally {
    dispatch(removeLoading());
  }
};
